"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Iquizeles color generator
 * @module lib/color.js;
 */

var palettes = [[[0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [1.0, 1.0, 1.0], [0.0, 0.33, 0.67]], [[0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [1.0, 1.0, 1.0], [0.0, 0.1, 0.2]], [[0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [1.0, 1.0, 1.0], [0.3, 0.2, 0.2]], [[0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [1.0, 1.0, 0.5], [0.8, 0.9, 0.3]], [[0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [1.0, 0.7, 0.4], [0.0, 0.15, 0.2]], [[0.5, 0.5, 0.5], [0.5, 0.5, 0.5], [2.0, 1.0, 0.0], [0.5, 0.2, 0.25]], [[0.8, 0.5, 0.4], [0.2, 0.4, 0.2], [2.0, 1.0, 1.0], [0.0, 0.25, 0.25]]];

var palette = palettes[0];

function channel(t, a, b, c, d, add, mul) {
  return a + b * Math.cos(2 * Math.PI * (c * t + d)) * mul + add;
}

function color(t, add, mul, alpha) {
  var a = void 0,
      b = void 0,
      c = void 0,
      d = void 0;
  var rgb = [];
  for (var i = 0; i < 3; i++) {
    a = palette[0][i];
    b = palette[1][i];
    c = palette[2][i];
    d = palette[3][i];
    rgb[i] = Math.round(channel(-t, a, b, c, d, add, mul) * 255);
  }
  if (alpha) {
    return "rgba(" + rgb + "," + alpha + ")";
  }
  return "rgb(" + rgb + ")";
}

exports.default = color;


//////////////////
// WEBPACK FOOTER
// ./client/lib/color.js
// module id = 261
// module chunks = 0